/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mapping_System_Doc_ExtractionInputs */

const en_mapping_system_doc_extraction = /** @type {(inputs: Mapping_System_Doc_ExtractionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document extraction`)
};

/**
* | output |
* | --- |
* | "Document extraction" |
*
* @param {Mapping_System_Doc_ExtractionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const mapping_system_doc_extraction = /** @type {((inputs?: Mapping_System_Doc_ExtractionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mapping_System_Doc_ExtractionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_mapping_system_doc_extraction(inputs)
});